import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const NavCard = styled.div`
	display: flex;
	padding: 1em;
	margin: 0.5%;
	height: 23.3vh;
	background-color: ${colors.white};
	box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.1);
	cursor: pointer;
`;
export const NavDivider = styled.div`
	margin: 10px;
	background-color: ${colors.grey3};
	width: 1px;
	height: 50px;
`;
export const CardValue = styled.div`
	display: block;
	font-size: 150%;
	font-weight: bolder;
`;

export const CardText = styled.div`
	display: flex;
	flex: 0.8;
	font-size: 110%;
	font-weight: 150;
	text-decoration: none;
	color: #8f8f8f;
	transition: all 0.5s ease-in-out;
	position: relative;

	&::before {
		content: attr(data-item);
		transition: 0.2s;
		color: ${colors.green300};
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		width: 0;
		overflow: hidden;
	}

	&:hover {
		&::before {
			width: 100%;
			transition: all 0.2s ease-in-out;
		}
	}
`;
export const SubNav = styled.div`
	display: flex;
	justify-content: space-evenly;
	align-items: center;
	width: 28.5vw;
	> svg {
		flex: 1;
	}
`;
